module.exports = __webpack_public_path__ + "static/experimental_setup-feff732222f394c8c2e9ecf2f1d23f45.png";